import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_cfg_fiscal_year_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  function: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  fiscal_type: fromDatatype.VarcharDatatypeInterface;
  set_of_books_hdr_guid: fromDatatype.GuidDataFieldInterface;
  period_method: fromDatatype.VarcharDatatypeInterface;
  start_year: fromDatatype.IntegerDatatypeClass;
  start_month: fromDatatype.IntegerDatatypeClass;
  start_week: fromDatatype.IntegerDatatypeClass;
  end_year: fromDatatype.IntegerDatatypeClass;
  end_month: fromDatatype.IntegerDatatypeClass;
  end_week: fromDatatype.IntegerDatatypeClass;
  closing_status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_fi_cfg_fiscal_year_hdr_RowClass
  implements bl_fi_cfg_fiscal_year_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  function: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  fiscal_type: fromDatatype.VarcharDatatypeInterface;
  set_of_books_hdr_guid: fromDatatype.GuidDataFieldInterface;
  period_method: fromDatatype.VarcharDatatypeInterface;
  start_year: fromDatatype.IntegerDatatypeClass;
  start_month: fromDatatype.IntegerDatatypeClass;
  start_week: fromDatatype.IntegerDatatypeClass;
  end_year: fromDatatype.IntegerDatatypeClass;
  end_month: fromDatatype.IntegerDatatypeClass;
  end_week: fromDatatype.IntegerDatatypeClass;
  closing_status: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}
